// get current date and time
export const currentDateAndTime = (isT) => {
    // Options to format time in 24-hour format
    let options = { hour12: false, hour: '2-digit', minute: '2-digit', second: '2-digit' };
    let formattedTime = new Date().toLocaleTimeString(undefined, options);
    let dateTime;
    if (isT === "T") {
        dateTime = `${new Date().toISOString()?.split("T")[0]}T${formattedTime}`;
    }
    else {
        dateTime = `${new Date().toISOString()?.split("T")[0]} ${formattedTime}`;
    }

    // console.log("new Date().toLocaleTimeString()", dateTime);
    return dateTime
}

export function formatDateWithTime(isDate) {
  // let options = { hour12: true, hour: '2-digit', minute: '2-digit' };
  let date=new Date(isDate);
  if(!isDate){
      date = new Date();
  }
   // This uses the user's device date and time

  const monthNames = ["Jan", "Feb", "Mar", "Apr", "May", "Jun",
      "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];

  const day = date.getDate().toString().padStart(2, '0');
  const month = monthNames[date.getMonth()];
  const year = date.getFullYear();

  const formattedDate = `${day}-${month}-${year}`;

  // Time options for HH:MM AM/PM format
  const timeOptions = {
      hour: '2-digit',
      minute: '2-digit',
      hour12: true,
  };

  const time = date.toLocaleTimeString(undefined, timeOptions); // Using undefined to use user's locale

  return `${formattedDate} ${time}`;
}

export const formatDate = (GettedDate) => {
    if (!GettedDate) {
      return ``;
    }
  
    const date = new Date(GettedDate);
    // if (isNaN(date.getTime())) {
    //   throw new Error("Invalid date format");
    // }
  
    // Array of month names
    const monthNames = [
      "Jan", "Feb", "Mar", "Apr", "May", "Jun",
      "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"
    ];
  
    // Get the day, month, and year
    const day = date.getDate();
    const month = monthNames[date.getMonth()];
    const year = date.getFullYear();
  
    // Return the formatted date string, with padded day
    return `${day.toString().padStart(2, '0')}-${month}-${year}`;
  }

  export const indianStates = [
    { state: "Andhra Pradesh", code: "AP" },
    { state: "Arunachal Pradesh", code: "AR" },
    { state: "Assam", code: "AS" },
    { state: "Bihar", code: "BR" },
    { state: "Chhattisgarh", code: "CG" },
    { state: "Goa", code: "GA" },
    { state: "Gujarat", code: "GJ" },
    { state: "Haryana", code: "HR" },
    { state: "Himachal Pradesh", code: "HP" },
    { state: "Jharkhand", code: "JH" },
    { state: "Karnataka", code: "KA" },
    { state: "Kerala", code: "KL" },
    { state: "Madhya Pradesh", code: "MP" },
    { state: "Maharashtra", code: "MH" },
    { state: "Manipur", code: "MN" },
    { state: "Meghalaya", code: "ML" },
    { state: "Mizoram", code: "MZ" },
    { state: "Nagaland", code: "NL" },
    { state: "Odisha", code: "OD" },
    { state: "Punjab", code: "PB" },
    { state: "Rajasthan", code: "RJ" },
    { state: "Sikkim", code: "SK" },
    { state: "Tamil Nadu", code: "TN" },
    { state: "Telangana", code: "TG" },
    { state: "Tripura", code: "TR" },
    { state: "Uttar Pradesh", code: "UP" },
    { state: "Uttarakhand", code: "UK" },
    { state: "West Bengal", code: "WB" },
    { state: "Andaman and Nicobar Islands", code: "AN" },
    { state: "Chandigarh", code: "CH" },
    { state: "Dadra and Nagar Haveli and Daman and Diu", code: "DN" },
    { state: "Delhi", code: "DL" },
    { state: "Jammu and Kashmir", code: "JK" },
    { state: "Ladakh", code: "LA" },
    { state: "Lakshadweep", code: "LD" },
    { state: "Puducherry", code: "PY" }
  ];
  